// extracted by mini-css-extract-plugin
export var circle = "_38-2";
export var icon = "_38-a";
export var iconHighlight = "_38-0";
export var lg = "_38-8";
export var md = "_38-7";
export var outline = "_38-4";
export var sm = "_38-6";
export var square = "_38-1";
export var xl = "_38-9";
export var xs = "_38-5";
export var xxs = "_38-3";